import type { AccessorialDetailsParams, AccessorialsFilters, TariffDetailsParams } from './models';

export const CACHE_KEYS = {
  accessorial: (accessorialKey: number) => [...CACHE_KEYS.all, 'accessorial', accessorialKey] as const,
  accessorialDetails: (params: AccessorialDetailsParams) => [...CACHE_KEYS.all, 'accessorialDetails', params] as const,
  accessorials: (filters: AccessorialsFilters, customerKey: number) =>
    [...CACHE_KEYS.all, 'accessorials', customerKey, filters] as const,
  all: ['pricing'] as const,
  availableAccessorialCodes: () => [...CACHE_KEYS.all, 'availableAccessorialCodes'] as const,
  pricingSearch: (filters: unknown) => [...CACHE_KEYS.all, 'pricingSearch', filters] as const,
  sortingOptions: () => [...CACHE_KEYS.all, 'sortingOptions'] as const,
  tariff: (tariffKey: number) => [...CACHE_KEYS.all, 'tariff', tariffKey] as const,
  tariffDetails: (params: TariffDetailsParams) => [...CACHE_KEYS.all, 'tariffDetails', params] as const,
  tariffPricing: (tariffKey: number) => [...CACHE_KEYS.all, 'tariffPricing', tariffKey] as const,
  tariffs: (filters: unknown) => [...CACHE_KEYS.all, 'tariffs', filters] as const,
} as const;
